import { Dialog, Transition } from '@headlessui/react'
import { Button, Input } from '@material-tailwind/react'
import { useState, Fragment } from 'react'
import * as yup from 'yup'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import { P } from '../../../components/typography/typography'
import practiceService from '../../../Services/practice.services'

const RenamePracticeDialog = (props: any) => {
  const [errorMessage, setErrorMessage] = useState('')

  const schema = yup.object().shape({
    name: yup.string().trim().required('Name is required'),
  })

  const formik = useFormik({
    initialValues: { name: props.data?.name ?? '' },
    validationSchema: schema,
    onSubmit: (values) => renamePractice(values.name),
    enableReinitialize: true, // Pick up the practice that was clicked
  })

  function closeModal() {
    props.stateManager()
    setErrorMessage('')
  }

  const renamePractice = async (name: string) => {
    setErrorMessage('')
    try {
      await practiceService.RenamePractice(props.data.id, name.trim())
      toast.success('Practice renamed successfully', { position: 'top-center' })
      props.GetPractices()
      closeModal()
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.error ?? 'Something went wrong')
    }
  }

  return (
    <div>
      <Transition appear show={props.isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <form className="mt-6" onSubmit={formik.handleSubmit}>
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title as="h1" className="font-medium leading-tight text-2xl mt-0 mb-2 text-black-600">
                      Rename Practice
                    </Dialog.Title>
                    <div className="relative p-6 flex-auto">
                      {/* The state is fixed once the practice exists, so it's shown but can't be edited */}
                      <p className="mb-4 text-slate-500">State: {props.data?.stateName}</p>
                      <div className="mb-4">
                        <Input label="Name" name="name" value={formik.values.name} onChange={formik.handleChange} />
                        {formik.touched.name && formik.errors.name && <P className="text-red-600">{formik.errors.name as string}</P>}
                      </div>
                      {errorMessage && <P className="text-red-600">{errorMessage}</P>}
                    </div>

                    <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                      <button
                        className="text-blue-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <Button type="submit" disabled={formik.isSubmitting}>
                        Rename
                      </Button>
                    </div>
                  </Dialog.Panel>
                </form>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}

export default RenamePracticeDialog
